module.exports = __webpack_public_path__ + "img/DJ.ec9774d2.svg";